import { createContext } from 'react';

const ProfileTabContext = createContext(null);
export default ProfileTabContext;
